const linkTo = (linkType, linkAddr, history) => {
  if (`${linkType}` === '2') {
    if (linkAddr === '#') return;
    linkAddr && window.open(linkAddr, '_blank');
  } else {
    let pathname = null;
    if (`${linkType}` === '1') {
      const arr = linkAddr.split(',');
      pathname = `/search?scatId=${arr[0]}&pcatId=${arr[1]}&catCode=${arr[2]}&ibsrp3Dl01=${
        arr[3]
      }&imseg6Dl01=${arr[4]}&imseg7Dl01=${arr[5]}`;
    }
    if (`${linkType}` === '3') {
      pathname = `/search?searchCodeType=searchValue&search=短 ${linkAddr}`;
    }
    pathname && history.push(pathname);
  }
};

export default linkTo;
